import { FhirBundleSdk } from "@metriport/fhir-sdk";
import { getDocumentReferenceRows } from "./raw-documents-rows";

export const metadata = {
  tableType: "DocumentReference",
  displayName: "Raw Documents",
  getRows: (bundle: FhirBundleSdk) => getDocumentReferenceRows({ bundle }),
};
